// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

export const isAppsUserInfoScheduledMergeDuplicateUsersRulesResult = objectOf({
  identifier: string,
  sort_order: string,
  tiebreaker_field: string,
  is_active: boolean,
});
